import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { selectedOrgId } from '@/common/utils/role.utils';
import { userIdentity } from '@/common/utils/user-identity';

export type LandingRouteName =
  | 'boq-admin-vendors'
  | 'no-projects-or-sites'
  | 'client-variations'
  | 'projects';

/** The route a signed-in user starts on in the active org: after login, an invite or an org switch. */
export const landingRouteName = (): LandingRouteName => {
  if (userIdentity.worksOnBoqDatabaseOnly()) return 'boq-admin-vendors';
  if (userIdentity.isBareOrgMember()) return 'no-projects-or-sites';
  if (userIdentity.isClientAnywhere()) return 'client-variations';
  return 'projects';
};

/** The login and invite landing, which leave the org out of the bare member's empty-state URL. */
export const landingRouteFor = (name: LandingRouteName): RouteLocationRaw =>
  name === 'no-projects-or-sites'
    ? { name }
    : { name, params: { organisationId: selectedOrgId.value } };

/** Where a refused route sends the user: the BOQ database is a BOQ-database-only user's only page. */
export const refusedRouteRedirect = (): { name: 'boq-admin-vendors' | 'no-permissions' } =>
  userIdentity.worksOnBoqDatabaseOnly()
    ? { name: 'boq-admin-vendors' }
    : { name: 'no-permissions' };

/** Whether a BOQ-database-only user was left on an empty state before their flag or ability arrived. */
export const isStrandedLanding = (route: Pick<RouteLocationNormalized, 'name'>): boolean =>
  (route.name === 'no-projects-or-sites' || route.name === 'no-permissions') &&
  userIdentity.worksOnBoqDatabaseOnly();
